export default {
  BUY_POINTS_TRANSACTIONS_LOAD: 'BUY_POINTS_TRANSACTIONS_LOAD',
  BUY_POINTS_TRANSACTIONS_FETCHED: 'BUY_POINTS_TRANSACTIONS_FETCHED',
};
